import type { MessageRef } from '@elara/domain/models/schemas/shortlist-schemas';

import { MessageContext } from './message-context.js';

/**
 * Provider component that supplies messageRef to child widgets
 */
export function MessageContextProvider({
  messageRef,
  isGenerating,
  children,
}: {
  messageRef?: MessageRef;
  isGenerating?: boolean;
  children: React.ReactNode;
}) {
  return <MessageContext.Provider value={{ messageRef, isGenerating }}>{children}</MessageContext.Provider>;
}
